import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod/v4';
import { RecoveryRequestPage } from '@pages/recovery';

const searchSchema = z.object({ redirect: z.string().optional() });

export const Route = createFileRoute('/$locale/request-login-link')({
  validateSearch: searchSchema,
  component: RequestLoginLinkRoute,
});

function RequestLoginLinkRoute() {
  const { locale } = Route.useParams();
  const { redirect } = Route.useSearch();
  return (
    <RecoveryRequestPage
      locale={locale as 'en' | 'ru'}
      purpose="login_link"
      redirectTo={redirect}
    />
  );
}
